//export const Tabs = [{
const tabs = [{
  'ID': 1,
  'Caption': 'Trace',
}, {
  'ID': 2,
  'Caption': "Notifications",
}, {
  'ID': 3,
  'Caption': "Tables",
}, {
  'ID': 4,
  'Caption': 'Settings',
},{
  'ID': 5,
  'Caption': 'QR Reader',
}
];

const adminSettings = [
  {
    "TestQuestions": [
      {
        "questions": [
          /*{
            "Question": "Password",
            "ColumnSpan": 2,
            "IsRequired": "false",
            "DisplayText": "Password",
          },
          {
            "Question": "PasswordButton",
            "ColumnSpan": 2,
            "IsRequired": "false",
            "DisplayText": ""
          },*/

          {
            "Question": "FirstName",
            "ColumnSpan": 2,
            "IsRequired": "true",
            "DisplayText": "First Name",
            "AttributeId": 919,
          },
          {
            "Question": "LastName",
            "ColumnSpan": 2,
            "IsRequired": "true",
            "DisplayText": "Last Name",
          },
          {
            "Question": "Email",
            "ColumnSpan": 2,
            "IsRequired": "false",
            "DisplayText": "Email",
          },
          {
            "Question": "PhoneNumber",
            "ColumnSpan": 2,
            "IsRequired": "true",
            "DisplayText": "Phone",
          },
          {
            "Question": "BusinessName",
            "ColumnSpan": 4,
            "IsRequired": true,
            "DisplayText": "Business Name",
          },
          {
            "Question": "BusinessDesc",
            "ColumnSpan": 4,
            "IsRequired": true,
            "DisplayText": "Business Descrption",
          },
          {
            "Question": "Address",
            "ColumnSpan": 4,
            "IsRequired": "true",
            "DisplayText": "Address 1",
          },
          {
            "Question": "Address1",
            "ColumnSpan": 4,
            "IsRequired": false,
            "DisplayText": "Address 2",
          },
          {
            "Question": "City",
            "ColumnSpan": 4,
            "IsRequired": "true",
            "DisplayText": "City",
          },
          {
            "Question": "State",
            "ColumnSpan": 2,
            "IsRequired": "true",
            "DisplayText": "State/Province",
          },
          {
            "Question": "ZipCode",
            "ColumnSpan": 2,
            "IsRequired": false,
            "DisplayText": "Postal Code",
          },
          {
            "Question": "WebsiteURL",
            "ColumnSpan": 4,
            "IsRequired": false,
            "DisplayText": "Website URL",
          },
          {
            "Question": "MenuURL",
            "ColumnSpan": 4,
            "IsRequired": false,
            "DisplayText": "Menu URL",
          }
        ]
      }
    ]
  }
];

const adminHomeTestData = [
  {
    "AdminHomeTestRecord": [
      {
        "Section": "AdminHome",
        "rows": [
          {
            "LocationId": "0",
            "Selected":false,
            "TableName": "Farmhouse Table 1",
            "Date": "9/3/2020 1:00 PM",
            "TableDesc": "Table 1",
            "Name": "Clark Kent",
            "FirstName": "Clark",
            "LastName": "Kent",
            "Phone": "860-555-5555",
            "Email": "clark@microsoft.com",
            "Address": "123 Fake St.",
            "City": "Smallville",
            "State": "KS",
            "ZipCode": "55555",
          },
          {
            "LocationId": "1",
            "Selected":false,
            "TableName": "Farmhouse Table 2",
            "Date": "9/3/2020 1:00 PM",
            "TableDesc": "Table 2",
            "Name": "Lois Lane",
            "FirstName": "Lois",
            "LastName": "Lane",
            "Phone": "802-555-5555",
            "Email": "lois@google.com",
            "Address": "456 Fake St.",
            "City": "Metropolis",
            "State": "KS",
            "ZipCode": "55555",
          },
          {
            "LocationId": "1",
            "Selected":false,
            "TableName": "Farmhouse Table 4",
            "Date": "9/3/2020 1:00 PM",
            "TableDesc": "Table 4",
            "Name": "Lex Luthor",
            "FirstName": "Lex",
            "LastName": "Luthor",
            "Phone": "802-555-5555",
            "Email": "lex@google.com",
            "Address": "789 Fake St.",
            "City": "Prison",
            "State": "KS",
            "ZipCode": "55555",
          },
          {
            "LocationId": "3",
            "Selected":false,
            "TableName": "Farmhouse Table 3",
            "Date": "9/3/2020 1:00 PM",
            "TableDesc": "Table 3",
            "Name": "Marion Cobretti",
            "Phone": "802-555-5555",
            "Email": "cobra@google.com",
            "Address": "1 Fake St.",
            "City": "Burlington",
            "State": "VT",
            "ZipCode": "55555",
          },
          {
            "LocationId": "4",
            "Selected":false,
            "TableName": "Farmhouse Table 3",
            "Date": "9/3/2020 2:00 PM",
            "TableDesc": "Table 3",
            "Name": "Judge Dredd",
            "Phone": "802-555-5555",
            "Email": "dredd@google.com",
            "Address": "2 Fake St.",
            "City": "Burlington",
            "State": "VT",
            "ZipCode": "55555",
          },
          {
            "LocationId": "5",
            "Selected":false,
            "TableName": "Farmhouse Table 3",
            "Date": "9/3/2020 3:00 PM",
            "TableDesc": "Table 3",
            "Name": "John Rambo",
            "Phone": "802-555-5555",
            "Email": "rambo@google.com",
            "Address": "3 Fake St.",
            "City": "Burlington",
            "State": "VT",
            "ZipCode": "55555",
          },
          {
            "LocationId": "6",
            "Selected":false,
            "TableName": "Farmhouse Table 3",
            "Date": "9/4/2020 3:00 PM",
            "TableDesc": "Table 3",
            "Name": "John Spartan",
            "Phone": "802-555-5555",
            "Email": "spartan@google.com",
            "Address": "4 Fake St.",
            "City": "Barre",
            "State": "VT",
            "ZipCode": "55555",
          },
        ]
      },
    ],
  }
];

const contactRelatedHistoryData = [
  {
    "ContactRelatedHistoryData": [
      {
        "Section": "AdminHome",
        "rows": [
          {
            "id": "0",
            "TableName": "Farmhouse Table 1",
            "Date": "8/18/2020",
            "TableDesc": "Good table",
            "Name": "Jimmy Olsen",
            "Phone": "860-555-5555",
            "Email": "olsen@microsoft.com",
            "Address": "123 Fake St.",
            "City": "Groton",
            "State": "VT",
            "ZipCode": "55555",
          },
          {
            "id": "1",
            "TableName": "Farmhouse Table 2",
            "Date": "8/17/2020",
            "TableDesc": "Good table",
            "Name": "Jimmy Kimmel",
            "Phone": "802-555-5555",
            "Email": "kimmel@google.com",
            "Address": "456 Fake St.",
            "City": "Barre",
            "State": "VT",
            "ZipCode": "55555",
          },
          {
            "id": "1",
            "TableName": "Farmhouse Table 3",
            "Date": "8/17/2020",
            "TableDesc": "Good table",
            "Name": "Jimmy Fallon",
            "Phone": "802-555-5555",
            "Email": "fallon@google.com",
            "Address": "789 Fake St.",
            "City": "Montpelier",
            "State": "VT",
            "ZipCode": "55555",
          },
        ]
      },
    ],
  }
];

const adminTablesTestData = [
  {
    "Section": "AdminTables",
    "rows": [
      {
        "TableId": "10222",
        "TableName": "Farmhouse Table 1",
        "TableDesc": "A prime table",
        "Url": "http://localhost:8080/dinesafevt#/contact-info?tableId=10222",
        "TableURL": "http://www.DineSafeVT/t12dr3",
      },
      {
        "TableId": "10223",
        "TableName": "Farmhouse Table 2",
        "TableDesc": "A good enough table",
        "Url": "http://localhost:8080/dinesafevt#/contact-info?tableId=10223",
        "TableURL": "http://www.DineSafeVT/z12dr0",
      },
      {
        "TableId": "12345",
        "TableName": "Farmhouse Table 3",
        "TableDesc": "Third table",
        "Url": "http://localhost:8080/dinesafevt#/contact-info?tableId=12345",
        "TableURL": "http://www.DineSafeVT/b12dr1",
      },
      {
        "TableId": "12346",
        "TableName": "Farmhouse Table 4",
        "TableDesc": "Fourth table",
        "Url": "http://localhost:8080/dinesafevt#/contact-info?tableId=12346",
        "TableURL": "http://www.DineSafeVT/a12df6",
      },
      {
        "TableId": "12347",
        "TableName": "Farmhouse Table 5",
        "TableDesc": "Fifth table",
        "Url": "http://localhost:8080/dinesafevt#/contact-info?tableId=1drtgd",
        "TableURL": "http://localhost:8080/dinesafevt#/contact-info?tableId=1drtgd",
      },
    ]
  },
];


export default {
  getAdminSettings(){
    return adminSettings;
  },
  getTabs(){
    return tabs;
  },
  getAdminHomeTestData(){
    return adminHomeTestData;
  },
  getAdminTablesTestData(){
    return adminTablesTestData;
  },
  getcontactRelatedHistoryData(){
    return contactRelatedHistoryData;
  }
};
  